import axios from 'axios';

// Use relative URL in production, full URL in development
const API_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' 
    ? '/api' 
    : 'http://localhost:8000/api'
);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verify: () => api.get('/auth/verify'),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const pagesAPI = {
  getPage: (language) => api.get(`/pages/${language}`),
  getAllPages: () => api.get('/pages/admin/all'),
  updatePage: (id, data) => api.put(`/pages/${id}`, data),
};

export const toursAPI = {
  getTours: (language) => api.get(`/tours/${language}`),
  getAllTours: () => api.get('/tours/admin/all'),
  createTour: (data) => api.post('/tours', data),
  updateTour: (id, data) => api.put(`/tours/${id}`, data),
  deleteTour: (id) => api.delete(`/tours/${id}`),
  uploadTourPdf: (id, file) => {
    const formData = new FormData();
    formData.append('pdf', file);
    return axios.post(`${API_URL}/tours/${id}/pdf`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
  },
  deleteTourPdf: (id) => api.delete(`/tours/${id}/pdf`),
};

export const photosAPI = {
  getPhotos: () => api.get('/photos'),
  getAllPhotos: () => api.get('/photos/all'),
  uploadPhoto: (formData) => {
    return axios.post(`${API_URL}/photos/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
  },
  updatePhoto: (id, data) => api.put(`/photos/${id}`, data),
  deletePhoto: (id) => api.delete(`/photos/${id}`),
};

export const languagesAPI = {
  getLanguages: () => api.get('/languages'),
  getAllLanguages: () => api.get('/languages/admin/all'),
  createLanguage: (data) => api.post('/languages', data),
  updateLanguage: (id, data) => api.put(`/languages/${id}`, data),
  deleteLanguage: (id) => api.delete(`/languages/${id}`),
};

export default api;
